// extracted by mini-css-extract-plugin
export default {"title":"Consultation_title__twPZq","sendOrder":"Consultation_sendOrder__FMj1l","msg":"Consultation_msg__2+eZq","pulse":"Consultation_pulse__4xe4Q"};